"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import viMessages from "i18n/locales/vi.json";
import enMessages from "i18n/locales/en.json";

type Key = "title" | "heading" | "desc" | "home";

/** not-found không nhận params → suy ngôn ngữ từ URL. */
const useNotFoundText = () => {
  const pathname = usePathname();
  const isEn = pathname === "/en" || !!pathname?.startsWith("/en/");
  const msg = (isEn ? enMessages : viMessages).notFound;
  return (key: Key) => msg[key];
};

/**
 * Gắn title 404 theo ngôn ngữ phía client. Next 15 bỏ qua metadata của
 * not-found dưới segment động, nên phải set cả VI lẫn EN (trước chỉ EN → VI rỗng).
 */
export default function NotFoundTitle() {
  const t = useNotFoundText();
  const title = t("title");
  useEffect(() => {
    document.title = title;
  }, [title]);
  return null;
}

/** Chữ trong thân trang 404 theo ngôn ngữ URL. */
export function NotFoundText({ k }: { k: Key }) {
  const t = useNotFoundText();
  return <>{t(k)}</>;
}
